import { request } from './index';

export type OrderItemType = {
  id: number;
  name: string;
  price: number;
  item: { weight: number };
};

export type CodeType = {
  id: number;
  text: string;
  amount: number;
};

export type OrderType = {
  id: number;
  status: boolean;
  orderItems: OrderItemType[];
  code: CodeType;
  price: number;
  paymentPrice: number;
  creditPrice: number;
};

export type CreateOrderDataType = {
  packages: number[];
};

export async function fetchOrder(orderId: number): Promise<OrderType> {
  return await request(true, { url: `/transactions/orders/${orderId}` });
}

export async function createOrder(data: CreateOrderDataType): Promise<OrderType> {
  return await request(true, {
    url: '/transactions/orders',
    method: 'POST',
    data
  });
}

export type PayOrderFromCreditDataType = { orderId: number };

export async function payOrderFromCredit({
  orderId
}: PayOrderFromCreditDataType): Promise<OrderType> {
  return await request(true, {
    url: `transactions/orders/${orderId}/pay-from-credit`,
    method: 'PATCH'
  });
}

export type UpdateOrderCodeDataType = { orderId: number; code: string | null };

export async function updateOrderCode({
  orderId,
  code
}: UpdateOrderCodeDataType): Promise<OrderType> {
  return await request(true, {
    url: `transactions/orders/${orderId}`,
    method: 'PATCH',
    data: { code }
  });
}
